module.exports = __webpack_public_path__ + "static/media/vadapav.5b2ed8fd.jpg";